import { createStyles, makeStyles } from "@material-ui/core/styles";

export { useModuleContainerStyles };

const useModuleContainerStyles = makeStyles(() =>
	createStyles({
		emptyText: {
			height: "50%",
			textAlign: "center",
			transform: "translateY(100%)",
		},
		iframe: {
			width: "100%",
			height: "100%",
			border: 0,
		},
	})
);
